// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface HostsGetOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface HostsListOptionalParams extends OperationOptions {}
